import React from 'react';

type RestrictionModalProps = {
  open: boolean;
  title?: string;
  message: string;
  actionLabel?: string;
  onAction: () => void;
};

export default function RestrictionModal({
  open,
  title = 'お知らせ',
  message,
  actionLabel = '閉じる',
  onAction,
}: RestrictionModalProps) {
  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
        <h2 className="text-lg font-bold text-gray-800">{title}</h2>
        <p className="mt-3 text-sm leading-relaxed text-gray-600">{message}</p>
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onAction}
            className="rounded-full bg-[#ff7a1a] px-5 py-2 text-sm font-semibold text-white hover:bg-[#e96d10] transition"
          >
            {actionLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
